import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import Button from 'components/Button';
import { Avatar } from 'components';
import { BaseEditField } from 'legacyComponents/styled/lib';
import { ButtonGroup } from 'legacyComponents/styles';

export const EditButton = styled(Button)`
  margin-left: 0;
  ${media.s`
    display: none;
  `}
`;

export const ProfileAvatar = styled(Avatar)`
  width: 120px;
  height: 120px;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  position: absolute;
  z-index: 2;
  -webkit-transform: withNamespaces3d(0, 0, 0);
  ${media.s`
    width: 100px;
    height: 100px;
  `}
`;

export const AvatarInputWrapper = styled(ProfileAvatar)`
  > div {
    border-radius: 100%;
    opacity: 1;
  }
  & .cropper {
    border-radius: 100%;
    overflow: hidden;
    z-index: 14;
    width: 120px;
    height: 120px;
    margin-bottom: 6px;
  }
  overflow: hidden;
`;

export const NameInput = styled(BaseEditField)`
  position: relative;
  width: 320px;
  font-size: 1.5em;
  margin: 130px auto 4px auto;
  display: block;
  > input {
    font-weight: 600;
    text-align: center;
    width: 100%;
  }
  ::placeholder {
    font-weight: 600;
  }
  ${media.s`
    margin: 110px auto 4px auto;
    font-size: 1.3em;
  `}
`;

export const DescriptionInput = styled(BaseEditField)`
  position: relative;
  width: 640px;
  font-size: 1.25em;
  line-height: 1.4;
  margin: 5px auto 6px auto;
  display: block;
  text-align: center;
  > textarea {
    padding: 0;
    text-align: center;
    min-height: inherit;
    line-height: 1.4;
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SettingsButtons = styled(ButtonGroup)`
  > button:first-of-type {
    margin-left: 0;
    margin-right: 6px;
  }
  & a > button:last-of-type {
    margin-right: 0;
    margin-left: 6px;
  }
  ${media.s`
    & button:last-of-type {
      margin-left: 0;
    }
  `}
`;

export const Fullname = styled.h1`
  font-size: 1.5em;
  margin: 130px 0 0 0;
  ${media.s`
    margin: 110px auto 4px auto;
    font-size: 1.3em;
  `}
`;

export const Username = styled.div`
  font-size: 0.875em;
  margin: 5px 0 0 0;
  font-weight: 600;
  color: ${props => props.theme.color.primary};
`;

export const Bio = styled.p`
  font-size: 1.25em;
  line-height: 1.4;
  margin: 5px auto 10px auto;
  ${media.s`
    font-size: 1.15em;
  `}
`;

export const ProfileInfo = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${props => props.theme.space[6]};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 640px;
  ${media.m`
    width: 600px;
  `}
  ${media.xs`
    width: 95%;
  `}
`;
